import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../../services/auth';
import '../LoginPage/LoginPage.css';
import logoSvg from '../../assets/landing/icons/logo.svg';

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33334 3.33334H16.6667C17.5833 3.33334 18.3333 4.08334 18.3333 5.00001V15C18.3333 15.9167 17.5833 16.6667 16.6667 16.6667H3.33334C2.41667 16.6667 1.66667 15.9167 1.66667 15V5.00001C1.66667 4.08334 2.41667 3.33334 3.33334 3.33334Z" stroke="#9C9AA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M18.3333 5L10 10.8333L1.66667 5" stroke="#9C9AA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page login-page">
      <div className="top-accent-bar"></div>

      <div className="auth-container">
        <div className="auth-branding">
          <Link to="/" className="auth-logo">
            <img src={logoSvg} alt="Marquee Couriers" />
          </Link>
          <div className="auth-branding-content">
            <h1>Forgot Password?</h1>
            <p>
              No worries! Enter your email address and we'll send you
              instructions to reset your password.
            </p>
          </div>
        </div>

        <div className="auth-form-section">
          <div className="auth-form-container">
            {!success ? (
              <>
                <div className="auth-form-header">
                  <h2>Reset Password</h2>
                  <p>Enter your registered email address</p>
                </div>

                <form className="auth-form" onSubmit={handleSubmit}>
                  {error && (
                    <div className="error-message" style={{
                      padding: '12px',
                      marginBottom: '20px',
                      backgroundColor: '#fee',
                      border: '1px solid #fcc',
                      borderRadius: '4px',
                      color: '#c33',
                      fontSize: '14px'
                    }}>
                      {error}
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <div className="input-wrapper">
                      <EmailIcon />
                      <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        required
                        disabled={loading}
                      />
                    </div>
                  </div>

                  <button type="submit" className="btn-submit" disabled={loading}>
                    {loading ? 'Sending...' : 'Send Reset Link'}
                  </button>
                </form>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <div style={{
                  width: '80px',
                  height: '80px',
                  margin: '0 auto 20px',
                  borderRadius: '50%',
                  background: '#d1fae5',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <h2 style={{ marginBottom: '12px', color: '#059669' }}>Check Your Email</h2>
                <p style={{ color: '#666', marginBottom: '24px' }}>
                  We've sent password reset instructions to <strong>{email}</strong>.
                  Please check your inbox and follow the link to reset your password.
                </p>
                <Link to="/login" className="btn-submit" style={{ textDecoration: 'none', display: 'inline-block' }}>
                  Back to Login
                </Link>
              </div>
            )}

            <p className="auth-switch">
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
